<template>
  <div class="batch-operations">
    <div>
      已选择
      <span class="count">{{ selectedTasks.length }}</span>
      条
    </div>
    <span class="line"></span>
    <div class="batch-btn-wrap" v-ps>
      <base-button @click="changeGroupVisible = true">移动</base-button>
      <base-button @click="deleteTasks">删除</base-button>
      <base-button @click="$refs.addNewParticipantDialog.open()">添加参与人</base-button>
      <base-button @click="$refs.updateOwnerDialog.open()">变更负责人</base-button>
      <base-button @click="$refs.updateRoleDialog.open()">变更负责角色</base-button>
      <base-button @click="$refs.changeParentDialog.open()">更改父任务</base-button>
      <base-button @click="changeMilestone(true)">标记为里程碑</base-button>
      <base-button @click="changeMilestone(false)">取消里程碑</base-button>
      <base-button @click="changeRisk(true)">标记为风险</base-button>
      <base-button @click="changeRisk(false)">取消风险</base-button>
      <base-button @click="$refs.batchUpdateDialog.open()">批量编辑</base-button>
    </div>
    <!--移动任务分组-->
    <base-dialog
      width="485px"
      class="move-task-dialog"
      :visible.sync="changeGroupVisible"
      show-close
    >
      <template v-slot:header>
        移动任务
      </template>
      <el-form>
        <el-form-item label="任务分组">
          <el-select v-model="targetGroupId" placeholder="请选择">
            <el-option
              v-for="item in taskGroupList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <base-button type="primary" @click="changeTaskGroup">保存</base-button>
        <base-button @click="changeGroupVisible = false">取消</base-button>
      </template>
    </base-dialog>
    <!--添加参与人-->
    <add-new-participant-dialog
      ref="addNewParticipantDialog"
      :roles="roles"
      :project-id="projectId"
      @select="addParticipant"
    ></add-new-participant-dialog>
    <!--更换负责人-->
    <update-owner-dialog
      ref="updateOwnerDialog"
      @select="updateOwner"
      :project-id="projectId"
    ></update-owner-dialog>
    <!--更换负责角色-->
    <update-role-dialog
      ref="updateRoleDialog"
      @select="updateAssignRoles"
      :project-id="projectId"
    ></update-role-dialog>
    <change-parent-dialog
      ref="changeParentDialog"
      :project-id="projectId"
      :task-group="taskGroup"
      :selected-tasks="selectedTasks"
      @select="changeParent"
    ></change-parent-dialog>
    <batch-update-dialog
      ref="batchUpdateDialog"
      :project-id="projectId"
      @select="batchUpdate"
    ></batch-update-dialog>
  </div>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import AddNewParticipantDialog from "@/components/Task/TeamDialog/AddNewParticipantDialog"
import UpdateOwnerDialog from "@/components/Task/TeamDialog/UpdateOwnerDialog"
import UpdateRoleDialog from "@/components/Task/TeamDialog/UpdateRoleDialog"
import * as TaskApi from "@/api/project/task"
import { getAllProjectRole } from "@/api/project/project"
import ChangeParentDialog from "@/components/Task/DetailDialog/ChangeParentDialog"
import BatchUpdateDialog from "@/views/Front/Project/TaskList/BatchUpdateDialog"

export default {
  name: "BatchOperation",
  components: {
    BatchUpdateDialog,
    ChangeParentDialog,
    BaseButton,
    BaseDialog,
    AddNewParticipantDialog,
    UpdateOwnerDialog,
    UpdateRoleDialog
  },
  props: {
    projectId: {
      type: String,
      required: true
    },
    taskGroup: Object,
    selectedTasks: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    selectedTaskIds() {
      return this.selectedTasks.map(task => task.id)
    },
    // 只包含父任务的id列表
    parentOnlyTaskIds() {
      return this.selectedTasks
        .filter(task => !this.selectedTaskIds.includes(task.parentId))
        .map(task => task.id)
    }
  },
  data() {
    return {
      // 设置分组
      changeGroupVisible: false,
      taskGroupList: [],
      targetGroupId: "",
      roles: []
    }
  },
  created() {
    TaskApi.getTaskGroupList(this.projectId).then(taskGroupList => {
      this.taskGroupList = taskGroupList
    })
    getAllProjectRole(this.projectId).then(roles => (this.roles = roles || []))
  },
  methods: {
    changeTaskGroup() {
      TaskApi.changeTaskGroup(this.parentOnlyTaskIds, this.targetGroupId).then(() => {
        this.targetGroupId = ""
        this.changeGroupVisible = false
        this.$message.success("操作成功")
        this.$emit("data-changed")
      })
    },
    deleteTasks() {
      this.$confirm("删除后无法恢复,确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        TaskApi.deleteTask(this.selectedTaskIds).then(() => {
          this.$message.success("操作成功")
          this.$emit("data-changed")
        })
      })
    },
    addParticipant(userIds, roleIds) {
      TaskApi.addParticipant(this.selectedTaskIds, userIds, roleIds).then(() => {
        this.$message.success("操作成功")
        this.$emit("data-changed")
      })
    },
    updateOwner({ ownerId, partFlag }) {
      TaskApi.updateOwner(this.selectedTaskIds, ownerId, partFlag).then(() => {
        this.ownerId = ""
        this.$message.success("操作成功")
        this.$emit("data-changed")
      })
    },

    updateAssignRoles({ roleId }) {
      console.log('this.selectedTaskIds',this.selectedTaskIds,'roleId',roleId)
      TaskApi.updateAssignRoles(this.selectedTaskIds, roleId).then(() => {
        this.$message.success("操作成功")
        this.$emit("data-changed")
      })
    },

    changeParent({ taskIds, selectedVal }) {
      TaskApi.changeTaskParent(taskIds, selectedVal.id).then(() => {
        this.$message.success("操作成功")
        this.$emit("data-changed")
      })
    },
    changeMilestone(val) {
      this.$confirm("确认将任务" + (val ? "标记为里程碑？" : "取消里程碑？"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        TaskApi.batchSetTaskMilestone(this.selectedTaskIds, val).then(() => {
          this.$message.success("操作成功")
          this.$emit("data-changed")
        })
      })
    },
    changeRisk(val) {
      this.$confirm("确认将任务" + (val ? "标记为风险？" : "取消风险？"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        TaskApi.batchSetTaskRisk(this.selectedTaskIds, val).then(() => {
          this.$message.success("操作成功")
          this.$emit("data-changed")
        })
      })
    },
    batchUpdate({ property, value }) {
      TaskApi.batchUpdate(this.selectedTaskIds, property, value).then(() => {
        this.$message.success("操作成功")
        this.$emit("data-changed")
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-operations {
  display: flex;
  align-items: center;
  margin-left: 16px;
  margin-right: 210px;
  height: 40px;

  .count {
    color: #3e84e9;
    margin: 0 5px;
  }

  .line {
    width: 0;
    height: 28px;
    margin: 0 16px;
    border-left: 1px solid #dee1e6;
    overflow: hidden;
  }

  .batch-btn-wrap {
    display: flex;
    flex: 1;
    overflow: hidden;

    ::v-deep {
      .base-button {
        height: 30px;
        padding: 0 18px;
      }
    }
  }
}

.move-task-dialog {
  .el-form {
    margin-top: 18px;

    ::v-deep {
      .el-form-item__content {
        display: flex;

        .el-select {
          flex: 1;
        }
      }
    }
  }
}
</style>
